module.exports = __webpack_public_path__ + "img/Kata-i-morker.0b35b7af.jpg";